export const Account = {
  ['About']: '/About',
  ['Team']: '/AccountManagement',
  ['Admin Console']: '/Admin',
  ['Blog']: '/Blog',
  ['Calendar']: '/Calendar',
  ['Client Dashboard']: '/ClientDashboard',
  ['Client Management']: '/client-management',
  ['Contact']: '/Contact',
  ['Dashboard']: '/Dashboard',
  ['Settings']: '/Settings',
  ['Two-Factor Authentication']: '/mfa/setup',
  ['Home']: '/',
  ['Services']: '/Services',
  ['Sign Out']: '/SignOut',
  ['Update My Info']: '/Profile',
} as { [title: string]: string };
